/* LatestPromptHeader.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import "./LatestPromptHeader.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
/** @jsxFrag */
import React from 'react';
import { useIntl } from 'react-intl-next';
import { Box, Flex, Text } from '@atlaskit/primitives/compiled';
import { useAgentRefinementTagProps } from '../../hooks/use-agent-refinement-tag-props';
import { BackIconButton } from '../BackIconButton/BackIconButton';
import { ClosePreviewIconButton } from '../ClosePreviewIconButton/ClosePreviewIconButton';
import { EditPromptHoverTag } from '../EditPromptHoverTag/EditPromptHoverTag';
import { LatestPromptRenderer } from '../LatestPromptRenderer/LatestPromptRenderer';
import { RefinementTag } from '../RefinementTag/RefinementTag';
import { messages } from './messages';
var PROMPT_CONTENT_ID = 'ai-latest-prompt-content';

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var headerEditStylesUnbounded = null;
var headerEditStyles = null;

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var contentContainerStylesUnbounded = null;
var contentContainerStyles = null;
var fullWidth = {
  default: "_1bsb1osq"
};
var titleContentWrapper = {
  default: "_16jlkb7n _1ul9idpf"
};

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var headerStylesUnbounded = null;
var headerStyles = null;

// header has width/padding at the same time
// if there is very long prompt, header will be wider than parent
// so it should be border-box
var headerBoxSizingStyles = null;
export var LatestPromptHeader = function LatestPromptHeader(_ref) {
  var parentPresetPromptLabel = _ref.parentPresetPromptLabel,
    childShortTitle = _ref.childShortTitle,
    prompt = _ref.prompt,
    promptADF = _ref.promptADF,
    presetTitle = _ref.presetTitle,
    providerFactory = _ref.providerFactory,
    onEditPromptClick = _ref.onEditPromptClick,
    isClearTitle = _ref.isClearTitle,
    agent = _ref.agent,
    showBack = _ref.showBack,
    onBack = _ref.onBack,
    onClose = _ref.onClose;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;

  // when used in Loading screen, there is no onEditPromptClick
  var canEdit = !!onEditPromptClick;
  var promptContent = React.useMemo(function () {
    if (promptADF) {
      return /*#__PURE__*/React.createElement(Flex, {
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(LatestPromptRenderer, {
        promptADF: promptADF,
        providerFactory: providerFactory
      }), !presetTitle && /*#__PURE__*/React.createElement(EditPromptHoverTag, {
        isClearMode: !presetTitle && !prompt,
        isPlaceholder: !canEdit
      }));
    }
    if (prompt) {
      return /*#__PURE__*/React.createElement("div", {
        className: ax(["_1reo15vq _18m915vq _1bto1l2s _o5721q9c _ct361wug _slp31hna"])
      }, prompt);
    }
    return null;
  }, [canEdit, prompt, promptADF, providerFactory, presetTitle]);
  var refinementTagProps = useAgentRefinementTagProps(agent);
  var header = React.useMemo(function () {
    return /*#__PURE__*/React.createElement(Flex, null, showBack && /*#__PURE__*/React.createElement(BackIconButton, {
      inPromptHeader: true,
      isDisabled: !canEdit,
      stopPropagation: true,
      onClick: onBack
    }), /*#__PURE__*/React.createElement(Flex, {
      direction: "column",
      gap: "space.050",
      xcss: titleContentWrapper.default
    }, presetTitle && /*#__PURE__*/React.createElement(Flex, {
      alignItems: "center"
    }, /*#__PURE__*/React.createElement("div", {
      onClick: function onClick(e) {
        e.stopPropagation();
        e.preventDefault();
      }
    }, isClearTitle ? /*#__PURE__*/React.createElement(Text, {
      weight: 'semibold'
    }, presetTitle) : /*#__PURE__*/React.createElement(RefinementTag, _extends({
      label: presetTitle
      // Ignored via go/ees005
      // eslint-disable-next-line react/jsx-props-no-spreading
    }, refinementTagProps, {
      onClick: canEdit ? function () {
        if (onBack) {
          onBack();
        }
      } : undefined
    }))), presetTitle && /*#__PURE__*/React.createElement(EditPromptHoverTag, {
      isClearMode: !!presetTitle && !prompt,
      isPlaceholder: !canEdit
    })), promptContent), !!onClose && /*#__PURE__*/React.createElement(ClosePreviewIconButton, {
      onClick: onClose
    }));
  }, [showBack, canEdit, onBack, presetTitle, isClearTitle, refinementTagProps, prompt, promptContent, onClose]);
  if (!(prompt || presetTitle)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    testId: "prompt-header",
    xcss: fullWidth.default
  }, !canEdit ? /*#__PURE__*/React.createElement("div", {
    id: PROMPT_CONTENT_ID,
    "data-testid": PROMPT_CONTENT_ID,
    className: ax(["_1reo15vq _18m915vq _ca0qutpp _n3tdutpp _19bvutpp _u5f3utpp _1i4q1hna _1bsb1osq", "_gh0qgktf", "_vchhusvi", "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _ct361wug _slp31hna", "_vwz4gktf"])
  }, header) : /*#__PURE__*/React.createElement("button", {
    type: "button",
    "data-testid": "edit-prompt-button",
    onClick: onEditPromptClick,
    "aria-label": formatMessage(messages.editPrompt),
    "aria-describedby": PROMPT_CONTENT_ID,
    className: ax(["_1reo15vq _18m915vq _ca0qutpp _n3tdutpp _19bvutpp _u5f3utpp _1i4q1hna _1bsb1osq", "_gh0qgktf", "_vchhusvi", "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _ct361wug _slp31hna", "_vwz4gktf", "_19itglyw _2rkopd34 _80omtlke _1bsb1osq _bfhk1j28 _y3gnv2br", "_syaz1kw7 _1wybn7od _vwz41kw7 _mrkbidpf _1o0zidpf _gemckb7n _y2mv12j9 _1bg41i6y _irr3166n _1di61dty"]),
    style: {
      "--_toyvsf": ix("2px solid ".concat("var(--ds-border-focused, #388BFF)"))
    }
  }, /*#__PURE__*/React.createElement("div", {
    id: PROMPT_CONTENT_ID,
    "data-testid": PROMPT_CONTENT_ID
  }, header)));
};